// --- Our Modules --------------------------------------------------------------------------------
import Skeleton from "@/UI/atoms/Skeleton";
import "./styles.css";

// --- Logic --------------------------------------------------------------------------------------

export default function Loader() {
    return (
        <div className="one-store-screen">
            <Skeleton className="one-store-skeleton-head" />
            {Array.from({ length: 3 }, (_, index) => (
                <Skeleton key={index} className="one-store-skeleton-section" />
            ))}
        </div>
    );
}
